/* Alle Produkte stehen bereits im HTML; JavaScript ergänzt die Reiter-Bedienung. */
if (!customElements.get('pg-start-reiter')) {
  customElements.define('pg-start-reiter', class extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-enhanced')) return;
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      if (!this.tabs.length) return;
      this.onClick = (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (this.tabs.includes(tab)) this.select(this.tabs.indexOf(tab));
      };
      this.onKeydown = (event) => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0) return;
        let next;
        switch (event.key) {
          case 'ArrowRight': next = index + 1; break;
          case 'ArrowLeft': next = index - 1; break;
          case 'Home': next = 0; break;
          case 'End': next = this.tabs.length - 1; break;
          default: return;
        }
        event.preventDefault();
        next = (next + this.tabs.length) % this.tabs.length;
        this.select(next);
        this.tabs[next].focus();
      };
      this.onBlockSelect = (event) => {
        const index = this.panels.findIndex((panel) => panel.dataset.blockId === event.detail?.blockId);
        if (index >= 0) this.select(index);
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      this.select(Math.max(0, this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true')));
      this.setAttribute('data-enhanced', '');
    }

    select(index) {
      this.tabs.forEach((tab, position) => {
        const selected = position === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        const panel = this.panels.find((item) => item.id === tab.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.removeAttribute('data-enhanced');
    }
  });
}

/* Native Wischreihe; die Punkte folgen der jeweils nächsten Kartenposition. */
if (!customElements.get('pg-start-wischreihe')) {
  customElements.define('pg-start-wischreihe', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-pg-track]');
      this.cards = Array.from(this.querySelectorAll('[data-pg="karte"]'));
      this.dots = Array.from(this.querySelectorAll('[data-pg="punkt"]'));
      if (!this.track || !this.cards.length || this.onScroll) return;
      this.update = () => {
        if (!this.track.clientWidth) return;
        const firstLeft = this.cards[0].getBoundingClientRect().left;
        let nearest = 0;
        let distance = Infinity;
        this.cards.forEach((card, index) => {
          const position = card.getBoundingClientRect().left - firstLeft;
          const nextDistance = Math.abs(position - this.track.scrollLeft);
          if (nextDistance < distance) { distance = nextDistance; nearest = index; }
        });
        this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === nearest));
      };
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      };
      this.track.addEventListener('scroll', this.onScroll, {passive: true});
      if (typeof ResizeObserver !== 'undefined') {
        this.observer = new ResizeObserver(this.onScroll);
        this.observer.observe(this.track);
      }
      this.update();
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.onScroll);
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
      this.onScroll = null;
    }
  });
}
